import { Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";
import TikTokIcon from "./TikTokIcon";

const FACEBOOK_URL =
  "https://www.facebook.com/share/1CVqa1Uwox/?mibextid=wwXIfr";
const TIKTOK_URL = "https://www.tiktok.com/@pratts.hydroseeding";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden border-t border-[#0a1d14] bg-[#0e241a]"
    >
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-20 sm:px-8 lg:px-16">
        <div className="flex flex-wrap items-start justify-between gap-10">
          <div className="flex items-center gap-4">
            <img
              src="/logo.jpg"
              alt="Pratt's Hydroseeding & Excavating logo"
              className="h-16 w-16 rounded-md object-cover ring-1 ring-[#f6f1e3]/25"
            />
            <div>
              <p className="font-display text-lg font-bold uppercase text-[#f6f1e3]">
                Pratt's
              </p>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#9fd8b4]">
                Hydroseeding & Excavating
              </p>
            </div>
          </div>
          <div className="flex items-center gap-10 font-mono text-xs uppercase tracking-[0.2em]">
            {[
              { label: "Services", href: "#services", testid: "footer-link-services" },
              { label: "Results", href: "#results", testid: "footer-link-results" },
              { label: "Contact", href: "#contact", testid: "footer-link-contact" },
            ].map((l) => (
              <button
                key={l.href}
                data-testid={l.testid}
                onClick={() => scrollToId(l.href)}
                className="text-[#9db3a1] transition-colors duration-300 hover:text-[#f6f1e3]"
              >
                {l.label}
              </button>
            ))}
            <Link
              to="/before-after"
              data-testid="footer-link-beforeafter"
              className="text-[#9db3a1] transition-colors duration-300 hover:text-[#f6f1e3]"
            >
              Before / After
            </Link>
            <a
              data-testid="footer-facebook-link"
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Pratt's on Facebook"
              className="text-[#9db3a1] transition-colors duration-300 hover:text-[#f6f1e3]"
            >
              <Facebook className="h-5 w-5" />
            </a>
            <a
              data-testid="footer-tiktok-link"
              href={TIKTOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Pratt's on TikTok"
              className="text-[#9db3a1] transition-colors duration-300 hover:text-[#f6f1e3]"
            >
              <TikTokIcon className="h-5 w-5" />
            </a>
          </div>
        </div>

        <p
          data-testid="footer-massive-brand"
          className="text-outline mt-16 select-none text-center font-display text-[16vw] font-extrabold uppercase leading-none lg:text-[11rem]"
        >
          Pratt's
        </p>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-[#f6f1e3]/10 pt-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#7d937f]">
            © {new Date().getFullYear()} Pratt's Hydroseeding & Excavating ·
            East Tennessee
          </p>
          <a
            data-testid="footer-phone-link"
            href="tel:+14237482012"
            className="font-mono text-xs font-bold tracking-[0.25em] text-[#9fd8b4] transition-colors duration-300 hover:text-[#f6f1e3]"
          >
            423-748-2012
          </a>
        </div>
      </div>
    </footer>
  );
}
